// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__T56Uv","label":"styles_label__9ilNx","icon":"styles_icon__RZwxe"};